const EmphasisIcon = () => {
    return <img src={process.env.PUBLIC_URL + '/style/img/btn-icon/ico-error-popup.png'} />;
};

export default EmphasisIcon;
